// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Referral History: nested downline + icon control */
.refrefer_earn_outer .referral_tree_table {
  table-layout: auto;
  width: 100%;
}

.refrefer_earn_outer .referral_tree_table tr.referral_tree_child td {
  background: rgba(30, 86, 245, 0.04);
}

body.light_theme .refrefer_earn_outer .referral_tree_table tr.referral_tree_child td {
  background: rgba(30, 86, 245, 0.06);
}

.refrefer_earn_outer .referral_tree_table td.referral_tree_cell--branch {
  border-left: 3px solid rgba(30, 86, 245, 0.45);
  box-shadow: inset 2px 0 0 rgba(30, 86, 245, 0.12);
}

body.light_theme .refrefer_earn_outer .referral_tree_table td.referral_tree_cell--branch {
  border-left-color: rgba(30, 86, 245, 0.4);
}

.refrefer_earn_outer .referral_downline_icon_btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  line-height: 1;
  border-radius: 8px;
  border: 1px solid var(--bs-primary, #0d6efd);
  color: var(--bs-primary, #0d6efd);
  background: transparent;
  transition: background 0.15s, color 0.15s;
}

.refrefer_earn_outer .referral_downline_icon_btn i {
  font-size: 1.15rem;
}

.refrefer_earn_outer .referral_downline_icon_btn:hover:not(:disabled) {
  background: rgba(13, 110, 253, 0.12);
  color: var(--bs-primary, #0d6efd);
}

.refrefer_earn_outer .referral_downline_icon_btn:disabled {
  opacity: 0.65;
}

.refrefer_earn_outer .referral_tree_mobile_node {
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  overflow: hidden;
}

body.light_theme .refrefer_earn_outer .referral_tree_mobile_node {
  border-color: rgba(0, 0, 0, 0.08);
}

.refrefer_earn_outer .referral_tree_mobile_node.referral_tree_mobile--child {
  background: rgba(30, 86, 245, 0.05);
  border-left: 3px solid rgba(30, 86, 245, 0.45);
}

body.light_theme .refrefer_earn_outer .referral_tree_mobile_node.referral_tree_mobile--child {
  background: rgba(30, 86, 245, 0.06);
}

.refrefer_earn_outer .referral_tree_mobile--child .order_datalist {
  border-left: none;
}

.refrefer_earn_outer .referral_tree_mobile_flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.refrefer_earn_outer .referral_tree_mobile_flex .referral_downline_icon_btn {
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/ui/Pages/ReferalPage/referralHistoryTree.css"],"names":[],"mappings":"AAAA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,8CAA8C;EAC9C,iDAAiD;AACnD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,4CAA4C;EAC5C,iCAAiC;EACjC,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Referral History: nested downline + icon control */\n.refrefer_earn_outer .referral_tree_table {\n  table-layout: auto;\n  width: 100%;\n}\n\n.refrefer_earn_outer .referral_tree_table tr.referral_tree_child td {\n  background: rgba(30, 86, 245, 0.04);\n}\n\nbody.light_theme .refrefer_earn_outer .referral_tree_table tr.referral_tree_child td {\n  background: rgba(30, 86, 245, 0.06);\n}\n\n.refrefer_earn_outer .referral_tree_table td.referral_tree_cell--branch {\n  border-left: 3px solid rgba(30, 86, 245, 0.45);\n  box-shadow: inset 2px 0 0 rgba(30, 86, 245, 0.12);\n}\n\nbody.light_theme .refrefer_earn_outer .referral_tree_table td.referral_tree_cell--branch {\n  border-left-color: rgba(30, 86, 245, 0.4);\n}\n\n.refrefer_earn_outer .referral_downline_icon_btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  padding: 0;\n  line-height: 1;\n  border-radius: 8px;\n  border: 1px solid var(--bs-primary, #0d6efd);\n  color: var(--bs-primary, #0d6efd);\n  background: transparent;\n  transition: background 0.15s, color 0.15s;\n}\n\n.refrefer_earn_outer .referral_downline_icon_btn i {\n  font-size: 1.15rem;\n}\n\n.refrefer_earn_outer .referral_downline_icon_btn:hover:not(:disabled) {\n  background: rgba(13, 110, 253, 0.12);\n  color: var(--bs-primary, #0d6efd);\n}\n\n.refrefer_earn_outer .referral_downline_icon_btn:disabled {\n  opacity: 0.65;\n}\n\n.refrefer_earn_outer .referral_tree_mobile_node {\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  overflow: hidden;\n}\n\nbody.light_theme .refrefer_earn_outer .referral_tree_mobile_node {\n  border-color: rgba(0, 0, 0, 0.08);\n}\n\n.refrefer_earn_outer .referral_tree_mobile_node.referral_tree_mobile--child {\n  background: rgba(30, 86, 245, 0.05);\n  border-left: 3px solid rgba(30, 86, 245, 0.45);\n}\n\nbody.light_theme .refrefer_earn_outer .referral_tree_mobile_node.referral_tree_mobile--child {\n  background: rgba(30, 86, 245, 0.06);\n}\n\n.refrefer_earn_outer .referral_tree_mobile--child .order_datalist {\n  border-left: none;\n}\n\n.refrefer_earn_outer .referral_tree_mobile_flex {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.refrefer_earn_outer .referral_tree_mobile_flex .referral_downline_icon_btn {\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
